__turbopack_context__.v({
  "errorBox": "styles-module__HBHW0a__errorBox",
  "placeOrderButton": "styles-module__HBHW0a__placeOrderButton",
  "section": "styles-module__HBHW0a__section",
});
